<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card class="justify-content-center">
        <v-card-title class="headline">
          Transaction Response
        </v-card-title>
        <v-card-text class="align-center">
          <template v-if="!gotResponse">
            Getting transaction details.
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </template>
          <template v-else>
            Message : {{ message }}
            <v-expansion-panels v-if="showMoreDetails">
              <v-expansion-panel>
                <v-expansion-panel-header
                  >More Details</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  {{ detailedMessage }}
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="closeModal">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { API, graphqlOperation } from "aws-amplify";
export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false
    },
    transactionId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      message: "",
      gotResponse: false,
      detailedMessage: ""
    };
  },
  methods: {
    closeModal() {
      this.$emit("closeFACResponseModal");
    },
    async getTransactionDetails() {
      const transactionDetailsQuery = `
                query {
                    retrieveFACResponse(transactionId: "${this.transactionId}") {
                        IsSuccessful
                        Message
                        DetailedMessage
                    }
                }`;
      const transactionDetailsResponse = await API.graphql(
        graphqlOperation(transactionDetailsQuery)
      );
      if (transactionDetailsResponse.data.retrieveFACResponse.IsSuccessful) {
        this.message =
          transactionDetailsResponse.data.retrieveFACResponse.Message;
        this.detailedMessage =
          transactionDetailsResponse.data.retrieveFACResponse.DetailedMessage;
      } else {
        this.message = "Failed to retrieve transaction details.";
        this.detailedMessage = "";
      }
    }
  },
  watch: {
    async dialog(showDialog) {
      if (showDialog) {
        await this.getTransactionDetails();
        this.gotResponse = true;
      } else {
        this.gotResponse = false;
      }
    }
  },
  computed: {
    showMoreDetails() {
      if (!this.detailedMessage) {
        return false;
      }
      return (
        this.message.toLowerCase().replace(/[^a-z\s]/g, "") !==
        this.detailedMessage.toLowerCase().replace(/[^a-z\s]/g, "")
      );
    }
  }
};
</script>

<style scoped></style>
